import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material';

export const ShellAndTubeDryIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Shell body - longer and sleeker */}
      <rect x="2" y="8" width="20" height="8" rx="0.5" stroke="currentColor" strokeWidth="1" fill="none" />
      
      {/* Tube sheets at ends - extended above and below */}
      <rect x="1" y="6" width="1" height="12" fill="currentColor" />
      <rect x="22" y="6" width="1" height="12" fill="currentColor" />

      {/* End caps - sleeker design */}
      <path d="M2 8 L22 8 L22 7 L2 7 Z" fill="currentColor" />
      <path d="M2 16 L22 16 L22 17 L2 17 Z" fill="currentColor" />

      {/* Inlet and Outlet on the left side */}
      <rect x="-2" y="10" width="3" height="4" fill="currentColor" />
      
      {/* Two outlets on the front - left and right */}
      <circle cx="6" cy="12" r="1.5" stroke="currentColor" strokeWidth="0.5" fill="none" />
      <circle cx="18" cy="12" r="1.5" stroke="currentColor" strokeWidth="0.5" fill="none" />
    </SvgIcon>
  );
};
